import type { ColumnDef } from '@tanstack/react-table'
import { Badge } from '@/components/ui/badge'
import type CrmFundraisingCampaign from '@/types/serializers/CrmFundraisingCampaign'
import {
  CAMPAIGN_TYPE_LABELS,
  STATUS_BADGE_VARIANT,
} from '@/lib/fundraising-labels'

export const campaignColumns: ColumnDef<CrmFundraisingCampaign, unknown>[] = [
  {
    accessorKey: 'name',
    header: 'Nom',
    meta: { sortKey: 'name' },
    cell: ({ row }) => (
      <span className="font-medium">
        {row.original.name}
        {row.original.system && (
          <Badge variant="secondary" className="ml-2 text-xs">
            Systeme
          </Badge>
        )}
      </span>
    ),
  },
  {
    accessorKey: 'campaign_type',
    header: 'Type',
    cell: ({ row }) => {
      const ct = typeof row.original.campaign_type === 'object'
        ? row.original.campaign_type.value
        : row.original.campaign_type
      const ctStr = String(ct)
      return CAMPAIGN_TYPE_LABELS[ctStr] ?? row.original.campaign_type.label ?? ctStr
    },
  },
  {
    accessorKey: 'status',
    header: 'Statut',
    meta: { sortKey: 'status' },
    cell: ({ row }) => {
      const label = typeof row.original.status === 'object' ? row.original.status.label : String(row.original.status)
      return (
        <Badge variant="outline">{label}</Badge>
      )
    },
  },
  {
    accessorKey: 'goal_amount_formatted',
    header: 'Objectif',
    cell: ({ row }) => (
      <span className="tabular-nums">{row.original.goal_amount_formatted}</span>
    ),
  },
  {
    accessorKey: 'start_date',
    header: 'Debut',
    cell: ({ row }) =>
      row.original.start_date
        ? new Date(row.original.start_date).toLocaleDateString('fr-FR')
        : '-',
  },
  {
    accessorKey: 'end_date',
    header: 'Fin',
    cell: ({ row }) =>
      row.original.end_date
        ? new Date(row.original.end_date).toLocaleDateString('fr-FR')
        : '-',
  },
]
